import * as yup from 'yup';

export const schema = yup.object().shape({
    requestedStatus: yup.string().required(),
    passport: yup.string().length(9).required(),
    countryOfCitizenship: yup.string().required(),

});

export const fieldsForm = {


    requestedStatus: {
        elementType: 'select',
        controlId: 'RequestedStatus',
        value: '',
        className: 'wide'
    },
    passport: {
        elementType: 'input',
        controlId: 'Passport',
        value: '',
        className: ''
    },
    countryOfCitizenship: {
        elementType: 'select',
        controlId: 'CountryOfCitizenship',
        value: '',
        className: 'wide'

    },
}

